import { useState, useEffect } from "react";
import { allDatas } from "./utils/db";
import Header from "./components/Header";
import Footer from "./components/Footer";

import Products from "./products/Products";
import Sidebar from "./sidebar/Sidebar";

import "./index.css";

function App() {
  const [datas, setDatas] = useState(allDatas);

  // Radio filter
  const handleChange = (name, type) => {
    if (name === "all") setDatas(allDatas);
    else if (type === "coloring") {
      setDatas(allDatas.filter((data) => data.color === name));
    } else if (type === "categ") {
      setDatas(allDatas.filter((data) => data.category === name));
    } else if (type === "pricing") {
      setDatas(allDatas.filter((data) => Number(data.newPrice) === name));
    }
  };

  // Button filter
  const handleClick = (name) => {
    if (name === "all") setDatas(allDatas);
    else {
      setDatas(allDatas.filter((data) => data.company === name));
    }
  };

  // input filter
  const handleInputChange = (value) => {
    setDatas(
      allDatas.filter(
        (data) => data.title.toLowerCase().indexOf(value.toLowerCase()) !== -1
      )
    );
  };

  return (
    <>
      <a href='https://www.mrhussain.in/portfolio/' className='back-btn'>Back to Portfolio</a>
      <Header handleInputChange={handleInputChange} />
      <div className="page-container">
        <Sidebar handleChange={handleChange} />
        <Products datas={datas} handleClick={handleClick} />
      </div>
      <Footer />
    </>
  );
}

export default App;
